import { useEffect, useState } from "react";
import {
  Form,
  useActionData,
  useNavigate,
  useNavigation,
} from "react-router-dom";

import Logo from "@/assets/logo.svg?react";
import { Button, Link } from "@/components/clickable";
import { TextField } from "@/components/forms";
import { HStack, VStack } from "@/components/layout";
import { VerifyCodeFields } from "@/modules/auth";
import { isSubmitting } from "@/utils";

export default function SignInView() {
  const navigate = useNavigate();
  const { state } = useNavigation();
  const [verifyCode, setVerifyCode] = useState(false);
  const data = useActionData();
  const formErrors = data?.formErrors || {};
  const error = data?.error || null;

  const handleVerifiedCode = () => {
    navigate("/");
  };

  useEffect(() => {
    if (data?.email) {
      setVerifyCode(true);
    }
  }, [data]);

  return (
    <div className="text-cp-body relative isolate flex min-h-svh w-full items-center justify-center p-6 max-lg:flex-col lg:bg-zinc-100">
      <Form method="post" className="flex w-full justify-center">
        <VStack className="h-fit w-full max-w-lg items-center justify-center gap-6 rounded-2xl bg-white px-6 py-6 shadow-lg">
          <HStack className="w-full justify-start">
            <Logo />
          </HStack>

          {verifyCode ? (
            <VerifyCodeFields
              email={data?.email}
              onCodeVerified={handleVerifiedCode}
              onReturn={() => setVerifyCode(false)}
            />
          ) : (
            <>
              <TextField
                name="email"
                label="Email"
                placeholder="Insert your email"
                error={formErrors.email}
              />

              {error && (
                <p className="text-xs font-semibold text-red-500">
                  Incorrect email
                </p>
              )}

              <div className="w-full">
                <Button
                  isLoading={isSubmitting(state)}
                  color="green"
                  className="w-full"
                  type="submit"
                >
                  Sign in
                </Button>

                <p className="mt-4 w-full text-center">
                  <Link className="text-sm" href="/sign-up">
                    Don&apos;t have an account?
                  </Link>
                </p>
              </div>
            </>
          )}
        </VStack>
      </Form>
    </div>
  );
}
